import { WARRAPP_NOTIFICATIONS_API_URL } from 'config';
import type {
  GetBannerMessagesResponseDTO,
  GetBannerMessagesResponseParamsDTO,
  GetNotificationsHistoryParamsDTO,
  GetNotificationsHistoryResponseDTO,
  GetPushNotificationsParamsDTO,
} from 'declarations/dto/notifications';

import { get, put } from './api';

export const getPushNotificationsApi = ({
  idToken,
  userId,
}: GetPushNotificationsParamsDTO): WebSocket =>
  new WebSocket(
    `${WARRAPP_NOTIFICATIONS_API_URL}?Authorization=Bearer ${idToken}&UserId=${userId}`
  );

export const getNotificationsHistoryApi = async (
  params: GetNotificationsHistoryParamsDTO
): Promise<GetNotificationsHistoryResponseDTO> => {
  const response = await get<GetNotificationsHistoryResponseDTO>(
    `/notifications/current-user`,
    params
  );

  return response.data;
};

export const updateNotificationHistoryStatusApi = async (notificationId: string): Promise<void> => {
  const response = await put<void>(`/notifications/${notificationId}/read`);

  return response.data;
};

export const updateNotificationsHistoryStatusApi = async (): Promise<void> => {
  const response = await put<void>(`/notifications/all/as-read`);

  return response.data;
};

export const updateNotificationsRoofTopHistoryStatus = async (roofTopId: string): Promise<void> => {
  const response = await put<void>(`/notifications/${roofTopId}/as-read`);

  return response.data;
};

export const getBannerMessagesApi = async (
  params: GetBannerMessagesResponseParamsDTO
): Promise<GetBannerMessagesResponseDTO> => {
  const response = await get<GetBannerMessagesResponseDTO>(`/banner-messages/current-user`, params);

  return response.data;
};
